import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  payWithPayPalOrProceedToCheckout: {
    id: 'checkout.cartPage.payPalExpress.payWithPayPalOrProceedToCheckout',
    defaultMessage: '* or *',
    description: 'Message that is being displayed between buttons if checkout express is enabled',
  },
  communicationError: {
    id: 'checkout.cartPage.payPalExpress.communicationError',
    defaultMessage: 'Issue has occurred while communicating with paypal. Please try again later.',
    description: 'Message that is being displayed between buttons if checkout express is enabled',
  },
});
